export default __webpack_public_path__ + "assets/bacellar-component.6a8ca92f.svg";